export default "__VITE_ASSET__Dye8jB0W__"